var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotaltransfer({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.599854,
    y: 0.600006,
    width: 60,
    height: 60,
    rx: 4.8,
    fill: "#151D58",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.25 35.25C48.25 42.0225 42.7725 47.5 36 47.5L37.8375 44.4375",
    stroke: "#151D58",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 24.75C13.25 17.9775 18.7275 12.5 25.5 12.5L23.6625 15.5625",
    stroke: "#151D58",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.25 16.35V16.5425C48.25 17.0325 47.865 17.4175 47.375 17.4175H31.625C31.135 17.4175 30.75 17.0325 30.75 16.5425V16.35C30.75 13.27 31.52 12.5 34.635 12.5H44.365C47.48 12.5 48.25 13.27 48.25 16.35Z",
    fill: "#151D58"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.625 19.1675C31.135 19.1675 30.75 19.5525 30.75 20.0425V21.7925V23.525C30.75 26.605 31.52 27.375 34.635 27.375H44.365C47.48 27.375 48.25 26.605 48.25 23.525V21.7925V20.0425C48.25 19.5525 47.865 19.1675 47.375 19.1675H31.625Z",
    fill: "#151D58"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.75 36.475V36.6675C30.75 37.1575 30.365 37.5425 29.875 37.5425H14.125C13.635 37.5425 13.25 37.1575 13.25 36.6675V36.475C13.25 33.395 14.02 32.625 17.135 32.625H26.865C29.98 32.625 30.75 33.395 30.75 36.475Z",
    fill: "#151D58"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.125 39.2925C13.635 39.2925 13.25 39.6775 13.25 40.1675V41.9175V43.65C13.25 46.73 14.02 47.5 17.135 47.5H26.865C29.98 47.5 30.75 46.73 30.75 43.65V41.9175V40.1675C30.75 39.6775 30.365 39.2925 29.875 39.2925H14.125Z",
    fill: "#151D58"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotaltransfer);
export default __webpack_public_path__ + "static/media/totaltransfer.fd6bfe13434339ebae2cb560ec5d102c.svg";
export { ForwardRef as ReactComponent };